import { CommonData } from "../../datastructures/gamestate/gameData";
import { autoRescale } from "../../functions/Functions_General";

export class portraitBGCommon
{
    private parent:PIXI.Container;
    private solidBG:PIXI.Graphics;
    private activeGameData:CommonData;
    private c_fillAll:PIXI.Container;
    private c_stickTop:PIXI.Container;
    private c_stickBot:PIXI.Container;
    private c_stickCenter:PIXI.Container;
    private c_stickTopLogo:PIXI.Container;
    private ruban:PIXI.Sprite;

    constructor(activeGameData:CommonData,parent:PIXI.Container)
    {   
        this.activeGameData=activeGameData;
        this.parent= new PIXI.Container();
        parent.addChild(this.parent);
        this.solidBG= new PIXI.Graphics();
        this.solidBG.beginFill(0x0f0fff);
        this.solidBG.drawRect(0,0,this.activeGameData.size[0],this.activeGameData.gameResolution[1]);
        this.solidBG.endFill();

        this.parent.addChild(this.solidBG);

        this.parent.alpha=0;
        this.c_fillAll= new PIXI.Container();
        this.c_stickTop= new PIXI.Container();
        this.c_stickCenter= new PIXI.Container();
        this.c_stickBot= new PIXI.Container();
        this.c_stickTopLogo= new PIXI.Container();
        this.parent.addChild(this.c_fillAll);
  
   
        this.parent.addChild(this.c_stickBot);
        this.parent.addChild(this.c_stickCenter);
        this.parent.addChild(this.c_stickTop);
        if(this.activeGameData.isTableGame==false)
        {
        this.parent.addChild(this.c_stickTopLogo);
        }
        //---create demo ribbon

 
    }


    public createDemoStickerPortrait=():void=>
    {
	//--demo sticker 
        // console.log('CREATE DEMO LOGO')
        this.ruban = new PIXI.Sprite(PIXI.Texture.fromImage("demoBG.png"));
  
        this.c_stickTopLogo.addChild(this.ruban );
        let textStyle= new PIXI.TextStyle(
			{	
			
				fontFamily: this.activeGameData.gameTextStyle.gameFont,
				fontSize: 30,
				fill: '#ffffff',
				//    fontWeight:"bold",
				lineHeight: 30,
				align: 'center',

				dropShadow: true,
				dropShadowColor: '#000000',
				dropShadowBlur: 10,
				dropShadowAngle: Math.PI / 6,
				dropShadowDistance: 0,
                wordWrap:true,
                wordWrapWidth:150
			});
        let demoText = new PIXI.Text(this.activeGameData.gameTextGeneral.demo, textStyle);
        this.ruban .addChild(demoText);
        demoText.anchor.set(.5);
        this.ruban .anchor.set(.5)
        this.ruban .scale.set(1.5)
        this.ruban .x=this.ruban .width/2+20;
        this.ruban .y=this.ruban .height/2+20;
        if(this.activeGameData.mainGame.onResize!=undefined)
        {
            this.activeGameData.mainGame.onResize();
        }
       
    }

    public disableDemo()
    {   

        if(this.ruban!=undefined)
        {
            this.ruban.scale.set(0) ;
        }
      
    }
    public getFillContainer=():PIXI.Container=>
    {
        return this.c_fillAll;
    }
    public getLogoContainer=():PIXI.Container=>
    {
        return this.c_stickTopLogo;
    }
    public getTopContainer=():PIXI.Container=>
    {
        return this.c_stickTop;
    }
    public getCenterContainer=():PIXI.Container=>
    {
        return this.c_stickCenter;
    }
    public getBotContainer=():PIXI.Container=>
    {
        return this.c_stickBot;
    }
    public getParent=():PIXI.Container=>
    {
        return this.parent;
    }
    public getSolidBG=():PIXI.Graphics=>
    {
        return this.solidBG;
    }
    public setNewHeight=(nHeight:number):void=>
    {
        this.solidBG.height=nHeight;
        this.updatePosition();
        this.updateVisibility();
    };
    public setNewWidthScale=(nWidthScale:number):void=>
    {
       
        this.solidBG.scale.x=nWidthScale;
        this.updatePosition();
        this.updateVisibility();
    };

    private updatePosition=():void=>
    {   
        autoRescale(this.c_stickTopLogo,this.activeGameData,this.activeGameData.app);
        autoRescale(this.c_stickTop,this.activeGameData,this.activeGameData.app);
        autoRescale(this.c_stickCenter,this.activeGameData,this.activeGameData.app);
        autoRescale(this.c_stickBot,this.activeGameData,this.activeGameData.app);
        // this.mobilePortraitBG.width=this.solidBG.width;
        // this.mobilePortraitBG.height=this.solidBG.height;
        //-------------
        this.c_fillAll.width=this.solidBG.width;
        this.c_fillAll.height=this.solidBG.height;   

        this.c_stickTopLogo.y=60
        this.c_stickTop.y=0;
        this.c_stickCenter.y=this.solidBG.height/2-this.c_stickBot.height/2;

      this.c_stickBot.y=this.solidBG.height;//-this.c_stickBot.height;

      

    }

    private updateVisibility=():void=>
    {   
 
        let screenRatio=window.innerHeight/window.innerWidth;
        let orientationPortrait = (window.matchMedia("(orientation: portrait)").matches);
        let verticalMode=false;
        if(orientationPortrait&& screenRatio>=this.activeGameData.minRatioForPortraitPlay)
        {
            verticalMode=true
        }
        if(this.activeGameData.isMobile && this.activeGameData.playOnPortrait && verticalMode)
        {
            this.parent.alpha=1;
            this.hideBaseGameBG(true);
        }
        else
        {
            this.parent.alpha=0;
            this.hideBaseGameBG(false);
        }
    }   


    private hideBaseGameBG=(bool:boolean):void=>
    {   
        let nAlpha=bool?0:1
        this.activeGameData.bgEnv.alpha=nAlpha;//nAlpha
        this.activeGameData.bgGradient.alpha=nAlpha;
        

        
    }
  
}